/**
 * Identifiants d'enregistrement (entree, dossier). Generes par le CSPRNG de
 * `@klavox/crypto-core` (jamais `Math.random`) : ils servent aussi de donnees
 * associees (AAD) au chiffrement, ils doivent donc etre imprevisibles et
 * pratiquement uniques sans coordination entre appareils.
 */
import { bytesToHex, randomBytes } from '@klavox/crypto-core';

/** UUID v4 (RFC 4122), forme lisible d'un identifiant genere localement. */
export function generateId(): string {
  const bytes = randomBytes(16);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = bytesToHex(bytes);
  return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
}
